import React from 'react'
import L from 'leaflet'
import { MapContainer, Marker, Polyline, TileLayer } from 'react-leaflet'
import length from '@turf/length'
import flip from '@turf/flip'
import { along } from '../utils/map'
import CONFIG from '../config'

class MapaFavoritos extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      time: 0,
      mapKey: 0
    }
    this.favoritosCoords = {}
    this.mapRef = React.createRef()
    this.boundsSet = false // Flag para saber si ya se ajustaron los bounds
  }

  // UNSAFE_componentWillReceiveProps(nextProps, nextState) {
  //   if (nextProps.turfBounds !== this.props.turfBounds) {
  //     this.setState({
  //       mapKey: this.state.mapKey + 1
  //     })
  //     this.boundsSet = false // Reset para permitir nuevo ajuste
  //   }
  // }

  // componentDidUpdate() {
  //   // Solo ajustar bounds UNA VEZ al inicio o cuando cambien los turfBounds
  //   if (this.mapRef.current &&
  //     this.props.turfBounds &&
  //     this.props.turfBounds.length === 4 &&
  //     !this.boundsSet) {
  //     const map = this.mapRef.current
  //     const { turfBounds } = this.props
  //     const bounds = [[turfBounds[0], turfBounds[1]], [turfBounds[2], turfBounds[3]]]
  //     map.fitBounds(bounds, { padding: [0, 0] })
  //     this.boundsSet = true // Marcar como ajustado
  //   }
  // }
  componentDidUpdate(prevProps) {
    // Detectar cuando cambian los turfBounds
    if (prevProps.turfBounds !== this.props.turfBounds) {
      this.setState({
        mapKey: this.state.mapKey + 1
      })
      this.boundsSet = false
    }

    // Solo ajustar bounds UNA VEZ al inicio o cuando cambien los turfBounds
    if (this.mapRef.current &&
      this.props.turfBounds &&
      this.props.turfBounds.length === 4 &&
      !this.boundsSet) {
      const map = this.mapRef.current
      const { turfBounds } = this.props
      const bounds = [[turfBounds[0], turfBounds[1]], [turfBounds[2], turfBounds[3]]]
      map.fitBounds(bounds, { padding: [0, 0] })
      this.boundsSet = true // Marcar como ajustado
    }
  }

  // Nuevo método para hacer zoom a un atleta específico
  flyToAtleta = (dorsal) => {
    if (this.mapRef.current && this.favoritosCoords[dorsal]) {
      const map = this.mapRef.current
      const coords = this.favoritosCoords[dorsal]

      // Hacer flyTo hacia el atleta con zoom 15
      map.flyTo(coords, 17, {
        duration: 1.5, // duración de la animación en segundos
        easeLinearity: 0.5
      })
    }
  }

  render() {
    const {
      resultados, geoJson, turfLine, turfBounds,
      sectores, controles, hideEmptyMessage
    } = this.props

    const turfLineGeoJSON = turfLine ? flip(turfLine) : turfLine

    const longitudRutaKm = turfLineGeoJSON
      ? (Array.isArray(turfLineGeoJSON)
        ? turfLineGeoJSON.reduce((sum, line) => sum + length(line), 0)
        : length(turfLineGeoJSON))
      : 0

    const distanciaMetaKm = controles && controles.length > 0
      ? Math.max(...controles.map(c => c.distancia)) / 1000.0
      : longitudRutaKm
    const factorCorreccion = distanciaMetaKm > 0 ? longitudRutaKm / distanciaMetaKm : 1

    let colorIndex = -1
    const colorValuesLength = CONFIG.COLORES_FAVORITOS.length

    const iconoSalida = new L.Icon({
      iconUrl: '/img/ico-salida-v2.png',
      iconSize: [22, 35],
      iconAnchor: [11, 35],
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null
    })
    const iconoMeta = new L.Icon({
      iconUrl: '/img/ico-meta-v2.png',
      iconSize: [22, 35],
      iconAnchor: [11, 35],
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null
    })
    const iconoControl = new L.Icon({
      iconUrl: '/img/ico-control-v2.png',
      iconSize: [22, 35],
      iconAnchor: [11, 35],
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null
    })

    let initialBounds = null
    if (turfBounds && turfBounds.length === 4) {
      initialBounds = [[turfBounds[0], turfBounds[1]], [turfBounds[2], turfBounds[3]]]
    }

    // RENDERIZAR CONTROLES
    let controlMarkers = []

    if (controles && controles.length) {
      controlMarkers = controles.map((control) => {
        if (control.visible && control.tipo !== 'META' && control.tipo !== 'SALIDA') {
          if (control.lat && control.lng) {
            return <Marker
              position={[control.lat, control.lng]}
              icon={iconoControl}
              key={`control-${control.id}`}
            />
          }

          if (sectores && sectores.length) {
            for (let i = 0; i < sectores.length; i++) {
              const s = sectores[i]
              const distanciaControl = parseInt(control.distancia, 10)

              if (distanciaControl >= s.inicio_metros && distanciaControl <= s.fin_metros) {
                if (turfLine[i]) {
                  const distanciaEnSector = distanciaControl - s.inicio_metros
                  const distanciaEnKm = distanciaEnSector / 1000.0

                  const longitudSectorKm = s.distanciaGeo / 1000.0
                  const proporcion = distanciaEnKm / (s.distancia / 1000.0)
                  const distanciaEnRutaKm = proporcion * longitudSectorKm

                  const puntoGeoJSON = along(flip(turfLine[i]), distanciaEnRutaKm)

                  if (!puntoGeoJSON || !puntoGeoJSON.geometry || !puntoGeoJSON.geometry.coordinates) {
                    return null
                  }
                  const [lng, lat] = puntoGeoJSON.geometry.coordinates
                  const leafletCoords = [lat, lng]

                  if (!leafletCoords || leafletCoords.length !== 2 || leafletCoords[0] == null || leafletCoords[1] == null) {
                    return null
                  }

                  return <Marker
                    position={leafletCoords}
                    icon={iconoControl}
                    key={`control-${control.id}`}
                  />
                }
                break
              }
            }
          } else {
            if (turfLine) {
              const distanciaEnKm = control.distancia / 1000.0
              const distanciaAjustada = distanciaEnKm * factorCorreccion

              const puntoGeoJSON = along(turfLineGeoJSON, distanciaAjustada)

              if (!puntoGeoJSON || !puntoGeoJSON.geometry || !puntoGeoJSON.geometry.coordinates) {
                return null
              }
              const [lng, lat] = puntoGeoJSON.geometry.coordinates
              const leafletCoords = [lat, lng]

              return <Marker
                position={leafletCoords}
                icon={iconoControl}
                key={`control-${control.id}`}
              />
            }
          }
        }
        return null
      }).filter((r) => r !== null)
    }

    // Marcadores de atletas favoritos
    const MapMarkers = resultados.map((resultado) => {
      colorIndex++
      let colorValue = CONFIG.COLORES_FAVORITOS[colorIndex % colorValuesLength]

      if (resultado.prevision.tiempo) {
        const customMarker = L.divIcon({
          className: 'custom-marker',
          iconSize: [40, 48],  // ancho y alto aproximado del marcador
          iconAnchor: [20, 48],
          html: `
            <div class="relative">
              <div class="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm border-2 border-white shadow-lg" style="background-color: ${colorValue}">
                ${resultado.nombre[0].toUpperCase()}${resultado.apellidos ? resultado.apellidos[0].toUpperCase() : ''}
              </div>
              <div class="absolute -bottom-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent" style="border-top: 8px solid ${colorValue}"></div>
            </div>
          `
        })

        let previsionPunto = null

        if (sectores.length) {
          const sectorIdx = resultado.prevision.sector_idx

          if (sectorIdx !== undefined &&
            sectores[sectorIdx] &&
            geoJson[sectorIdx] &&
            turfLine[sectorIdx]) {

            const geo = geoJson[sectorIdx]

            if (resultado.prevision.porcentaje === 100) {
              previsionPunto = geo[geo.length - 1]
            } else {
              const turfDistRel = sectores[sectorIdx].turfDistanceRelation || 1.0

              if (turfDistRel !== 0 && isFinite(turfDistRel)) {
                const distanciaAjustada = resultado.prevision.distancia / 1000.0 / turfDistRel

                if (isFinite(distanciaAjustada) && distanciaAjustada >= 0) {
                  const lineFeature = {
                    type: 'Feature',
                    geometry: turfLine[sectorIdx].geometry || turfLine[sectorIdx]
                  }

                  const ultimoControlConDatos = controles
                    .filter(c => c.visible && resultado.controles_pasados &&
                      resultado.controles_pasados.includes(c.id))
                    .sort((a, b) => b.distancia - a.distancia)[0]

                  if (ultimoControlConDatos && resultado.prevision.distancia > ultimoControlConDatos.distancia) {
                    const distanciaUltimoControl = ultimoControlConDatos.distancia
                    const distanciaAjustadaControl = distanciaUltimoControl / 1000.0 / turfDistRel

                    const previsionPointGeoJSON = along(flip(lineFeature), distanciaAjustadaControl)
                    const coordsGeoJSON = previsionPointGeoJSON ? previsionPointGeoJSON.geometry.coordinates : null
                    if (coordsGeoJSON && coordsGeoJSON.length === 2) {
                      previsionPunto = [coordsGeoJSON[1], coordsGeoJSON[0]]
                    } else {
                      previsionPunto = null
                    }
                  } else {
                    const previsionPointGeoJSON = along(flip(lineFeature), distanciaAjustada)
                    const coordsGeoJSON = previsionPointGeoJSON ? previsionPointGeoJSON.geometry.coordinates : null
                    if (coordsGeoJSON && coordsGeoJSON.length === 2) {
                      previsionPunto = [coordsGeoJSON[1], coordsGeoJSON[0]]
                    } else {
                      previsionPunto = null
                    }
                  }
                }
              }
            }
          }
        } else {
          if (resultado.prevision.porcentaje === 100) {
            previsionPunto = geoJson[geoJson.length - 1]
            // } else {
            //   const ultimoControlConDatos = controles
            //     .filter(c => c.visible && resultado.controles_pasados &&
            //       resultado.controles_pasados.includes(c.id))
            //     .sort((a, b) => b.distancia - a.distancia)[0]
          } else {
            // Usar control_ultimo_id en lugar de controles_pasados (que no existe)
            const ultimoControlConDatos = resultado.control_ultimo_id
              ? controles.find(c => c.id === String(resultado.control_ultimo_id))
              : null

            let distanciaParaCalculo = resultado.prevision.distancia

            // if (ultimoControlConDatos && distanciaParaCalculo > ultimoControlConDatos.distancia) {
            //   distanciaParaCalculo = ultimoControlConDatos.distancia
            // }
            // Si la previsión está ANTES del último control pasado, usar el control
            if (ultimoControlConDatos && resultado.prevision.distancia < ultimoControlConDatos.distancia) {
              distanciaParaCalculo = ultimoControlConDatos.distancia
            }

            const previsionPointGeoJSON = along(
              turfLineGeoJSON,
              distanciaParaCalculo / 1000.0 * factorCorreccion
            )

            const coordsGeoJSON = previsionPointGeoJSON ? previsionPointGeoJSON.geometry.coordinates : null
            if (coordsGeoJSON && coordsGeoJSON.length === 2) {
              previsionPunto = [coordsGeoJSON[1], coordsGeoJSON[0]]
            } else {
              previsionPunto = null
            }
          }
        }

        if (!previsionPunto || previsionPunto.length !== 2 ||
          isNaN(previsionPunto[0]) || isNaN(previsionPunto[1]) ||
          previsionPunto[0] == null || previsionPunto[1] == null) {
          return null
        }

        this.favoritosCoords[resultado.dorsal] = previsionPunto

        return <Marker
          icon={customMarker}
          position={[previsionPunto[0], previsionPunto[1]]}
          key={`resultado-${resultado.dorsal}-${previsionPunto[0]}-${previsionPunto[1]}`}
        />
      } else {
        return null
      }
    })

    return <div>
      <MapContainer
        key={this.state.mapKey}
        bounds={initialBounds}
        boundsOptions={{ padding: [0, 0] }}
        style={{ height: '400px', width: '100%' }}
        ref={this.mapRef}
      >
        <TileLayer url={CONFIG.MAP_LAYER} />

        {controlMarkers}
        {MapMarkers}

        {(sectores && sectores.length) ? (
          <>
            {geoJson && geoJson[0] && geoJson[0][0] && (
              <Marker
                position={geoJson[0][0]}
                icon={iconoSalida}
              />
            )}
            {geoJson && geoJson.length > 0 && geoJson[geoJson.length - 1] && (
              <Marker
                position={geoJson[geoJson.length - 1][geoJson[geoJson.length - 1].length - 1]}
                icon={iconoMeta}
              />
            )}

            {geoJson
              .map((g, i) => {
                const sector = sectores[i]
                if (!sector || !sector.mapa_geojson || !g || !g.length) return null

                const validPositions = g.filter(coord => coord && coord.length === 2 && coord[0] != null && coord[1] != null)
                if (validPositions.length === 0) return null

                const map = JSON.parse(sector.mapa_geojson)
                const lineFeature = map.features.find(f => f.geometry && f.geometry.type === 'LineString')
                const properties = lineFeature ? lineFeature.properties : { color: CONFIG.PRIMARY_COLOR }
                return <Polyline key={`sector-${i}`} color={properties.color} positions={validPositions} />
              })
              .filter(p => p !== null)
            }
          </>
        ) : (
          <>
            {geoJson && geoJson[0] && (
              <Marker
                position={geoJson[0]}
                icon={iconoSalida}
              />
            )}
            {geoJson && geoJson.length > 0 && geoJson[geoJson.length - 1] && (
              <Marker
                position={geoJson[geoJson.length - 1]}
                icon={iconoMeta}
              />
            )}
            <Polyline color={CONFIG.PRIMARY_COLOR} positions={geoJson} />
          </>
        )}
      </MapContainer>

      {MapMarkers.length === 0 && !hideEmptyMessage &&
        <div className="text-center py-4 text-gray-600 italic font-montserrat">
          Los atletas aparecerán en cuanto atraviesen algún punto de control
        </div>
      }
    </div>
  }
}

export default MapaFavoritos


